// extracted by mini-css-extract-plugin
module.exports = {"close-button":"PopupCloseButton_close-button__oJxi5","loader":"PopupCloseButton_loader____LwX"};